import type { MappedServiceObjectData, ServiceObjectSectionDisplayMode } from 'common/models';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectSections from './Sections/ServiceObjectSections';
import ServiceObjectTable from './ServiceObjectTable';
import ServiceObjectTableVertical from './ServiceObjectTableVertical';

interface OwnProps {
  data: MappedServiceObjectData[];
  serviceObjects: ServiceObjectInCustomer[];
  title?: string;
  displayMode: ServiceObjectSectionDisplayMode;
  columns?: number;
  width?: string;
}

const ServiceObjectData = (props: OwnProps) => {
  const { data, displayMode, title, serviceObjects, columns, width } = props;

  if (displayMode === 'sections') {
    return (
      <ServiceObjectSections
        data={data}
        serviceObjects={serviceObjects}
        columns={columns}
        width={width}
        title={title}
      />
    );
  }

  if (displayMode === 'tableVertical') {
    return (
      <div className="ReportSection ServiceObjectSection">
        {title && <div className="SectionTitle">{title}</div>}
        <ServiceObjectTableVertical data={data} serviceObjects={serviceObjects} />
      </div>
    );
  }

  return (
    <div className="ReportSection ServiceObjectSection">
      {title && <div className="SectionTitle">{title}</div>}
      <ServiceObjectTable data={data} serviceObjects={serviceObjects} />
    </div>
  );
};

export default ServiceObjectData;
